<script>
	import Autocomplete from "@smui-extra/autocomplete";
	import Textfield from "@smui/textfield";
	import Icon from "@smui/textfield/icon";
	import HelperText from "@smui/textfield/helper-text";
	import { isTranslationTooLong } from "../../../utils";

	export let string;
	export let input;
	export let original;
	export let suggestions;
	export let modified;
	export let isSuggestion;
	export let isMachineTranslation;
	export let isMissing;
	export let translation;
	export let is_long = undefined;

	let text = input;

	$: modified = (input !== original && !(original === null && input === "")) || !!isSuggestion;
	$: isMissing = !input || input === "";
	$: isTooLong = isTranslationTooLong(string?.length, input?.length);

	// as soon as a suggestion is changed, it's no longer considered a suggestion (relevant for CSS)
	$: if (input !== original && isSuggestion) isSuggestion = false;
</script>

<div class="translation" class:suggestion={isSuggestion} class:machine={isMachineTranslation} class:missing={isMissing} class:too-long={isTooLong}>
  <Autocomplete combobox options={suggestions} bind:value={input} bind:text label={string} getOptionLabel={x=>x.string}>
		<Textfield variant="filled" label={string} bind:value={text}>
			{#if isSuggestion && isMachineTranslation}
				<Icon class="material-icons" slot="leadingIcon">smart_toy</Icon>
			{/if}
			<HelperText slot="helper" persistent={isTooLong && !isMissing}>
				{#if isTooLong && !isMissing}
					Translation is significantly longer than original
				{/if}
			</HelperText>
		</Textfield>
	</Autocomplete>
</div>

<style lang="scss">
	.translation {
		:global(.smui-autocomplete) {
			width: 100%;
			max-width: 450px;
		}

		:global(.mdc-text-field--filled) {
			width: 100%;
		}
	}

	.suggestion {
		:global(.mdc-text-field__input) {
			caret-color: $warning !important;
			color: $warning !important;
		}

		:global(.mdc-floating-label) {
			color: $warning !important;
		}

		:global(.mdc-line-ripple::before) {
			border-bottom-color: $warning !important;
		}

		:global(.mdc-line-ripple::after) {
			border-bottom-color: $warning !important;
		}

		:global(.mdc-text-field--filled) {
			background-color: rgba($warning, 0.15) !important;
		}

		:global(.mdc-text-field--filled .mdc-text-field__ripple::before),
		:global(.mdc-text-field--filled .mdc-text-field__ripple::after) {
			background-color: $warning !important;
		}

		:global(.mdc-text-field__icon) {
			color: $warning !important;
		}
	}

	.missing {
		:global(.mdc-text-field__input) {
			caret-color: $error !important;
			color: $error !important;
		}

		:global(.mdc-floating-label) {
			color: $error !important;
		}

		:global(.mdc-line-ripple::before) {
			border-bottom-color: $error !important;
		}

		:global(.mdc-line-ripple::after) {
			border-bottom-color: $error !important;
		}

		:global(.mdc-text-field--filled) {
			background-color: rgba($error, 0.15) !important;
		}

		:global(.mdc-text-field--filled .mdc-text-field__ripple::before),
		:global(.mdc-text-field--filled .mdc-text-field__ripple::after) {
			background-color: $error !important;
		}
	}

	.too-long {
		$length-warning: #ffc107; // amber-500

		:global(.mdc-text-field__input) {
			caret-color: $length-warning !important;
		}

		:global(.mdc-line-ripple::before),
		:global(.mdc-line-ripple::after) {
			border-bottom-color: $length-warning !important;
		}

		:global(.mdc-text-field--filled) {
			background-color: rgba($length-warning, 0.15) !important;
		}

		:global(.mdc-text-field--filled .mdc-text-field__ripple::before),
		:global(.mdc-text-field--filled .mdc-text-field__ripple::after) {
			background-color: $length-warning !important;
		}

		:global(.mdc-text-field-helper-text) {
			color: $length-warning !important;
		}
	}

	.machine {
		:global(.mdc-text-field__icon) {
			position: relative;
			top: 6px;
			padding-left: 0;
			font-size: 20px;
			padding-right: 5px;
		}
	}
</style>
